import { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { BiLoaderAlt } from "react-icons/bi";
import { useTranslation } from "react-i18next";
import { TextInput } from "../UI/FormField";
import { updateOutreach } from "../../stores/actions/outreach.actions.types";
import { useParams } from "react-router-dom";
import History from "../../stores/services/history";

const UpdateOutreachForm = ({ updateOutreach, outreach }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    companyName: Yup.string().required(t("companyName-required")),
    name: Yup.string().required(t("name-required")),
    email: Yup.string().email(t("invalid-email")).required(t("email-required")),
    phone: Yup.string().required(t("phone-required")),
  });

  const handleSubmit = async (values, { resetForm }) => {
    setLoading(true);
    const callback = (data) => {
      if (data.success) {
        setLoading(false);
        resetForm();
        History.push("/outreaches");
      } else {
        setLoading(false);
      }
    };
    updateOutreach({ id, data: values, callback });
  };

  return (
    <div className='rounded-[10px] border border-stroke bg-white p-4 shadow-1 dark:border-dark-3 dark:bg-boxdark dark:shadow-card sm:p-7.5'>
      <div className='max-w-full overflow-x-auto'>
        <Formik
          enableReinitialize
          initialValues={{
            companyName: outreach?.companyName || "",
            name: outreach?.name || "",
            email: outreach?.email || "",
            phone: outreach?.phone || "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className='mx-auto space-y-4 rounded-md p-2 shadow-md'>
              {["companyName", "name", "email", "phone"].map((field) => (
                <TextInput
                  key={field}
                  label={t(field)}
                  id={field}
                  name={field}
                  type={field === "email" ? "email" : "text"}
                  placeholder={t(`placeholder-${field}`)}
                  className='block w-full text-black dark:text-white rounded-md border px-3 py-2 dark:bg-black'
                />
              ))}

              <button
                type='submit'
                disabled={loading || isSubmitting}
                className='w-full bg-red-600 text-white py-2 rounded-md'
              >
                {loading ? (
                  <BiLoaderAlt className='animate-spin text-2xl m-auto text-white' />
                ) : (
                  t("update-outreach")
                )}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ loading: state?.app?.visible });

export default connect(mapStateToProps, { updateOutreach })(UpdateOutreachForm);
